import React, { Component } from 'react';
import {
  IonTabs, IonTabButton, IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonPage,
} from '@ionic/react';
import { Plugins } from '@capacitor/core';
import { connect } from 'react-redux';
import { Route, Redirect, RouteComponentProps } from 'react-router';
import { sunny, map, person } from 'ionicons/icons';
import HomePage from './HomePage';
import MapView from './Map';
import Profile from './Profile';
import PlaceDetail from './PlaceDetail';
import CampgroundsDetails from './CampgroundsDetails';
import VisitorCenterDetails from './VisitorCenterDetails';
import AlertsDetails from './AlertsDetails';
import Reviews from './Reviews';
import Questions from './Questions';
import Photos from './Photos';
import MyParkPhotos from './MyParkPhotos';
import PhotoDetails from './PhotoDetails';
import { RootState, selectors, actions } from '../store';
import { Token } from '../store/users/types';
import localForage from 'localforage';

type Props =  RouteComponentProps<{}> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>;

class AppStack extends Component<Props> {
  constructor(props: Props) {
    super(props);

    props.getMyList();
    props.fetchAllParks();
    // this.props.checkApp();
  }

  async componentDidMount() {

    if (this.props.tokens && this.props.tokens.id_token) {
      return;
    }
    const queryParams: string = (window.location.search || '').substr(1) || '';
    if (queryParams) {
      return;
    }
    const tokens: any = await localForage.getItem('tokens');
    const todayTime = new Date().getTime();
    if (tokens && tokens.refresh_token) {
      if (!tokens.expired_at || tokens.expired_at < todayTime) {
        this.props.refreshTokens(tokens.refresh_token);
      } else {
        this.props.setTokens(tokens);
      }
      this.props.getUserInfo(tokens);
    }
  }

  render() {
    return (
      <IonPage>
        <Route exact path="/" render={() => <Redirect to="/places"/>}/>
        <IonTabs>
          <IonRouterOutlet use-hash={true}>
            <Route path="/:tab(places)" component={HomePage} exact={true} />
            <Route path="/:tab(profile)" component={Profile} exact={true} />
            <Route path="/:tab(profile)/places/:id" component={PlaceDetail} exact={true} />
            <Route path="/:tab(profile)/places/:id/campgrounds" component={CampgroundsDetails} exact={true} />
            <Route path="/:tab(profile)/places/:id/visitorcenters" component={VisitorCenterDetails} exact={true} />
            <Route path="/:tab(profile)/places/:id/alerts" component={AlertsDetails} exact={true} />
            <Route path="/:tab(profile)/places/:id/reviews" component={Reviews} exact={true} />
            <Route path="/:tab(profile)/places/:id/questions" component={Questions} exact={true} />
            <Route path="/:tab(profile)/places/:id/photos" component={Photos} exact={true} />
            <Route path="/:tab(profile)/places/:id/myphotos" component={MyParkPhotos} exact={true} />
            <Route path="/:tab(profile)/places/:id/photos/:photoid" component={PhotoDetails} exact={true} />
            {/* <Route path="/:tab(profile)/places/:id/questions/:questionId" component={QuestionDetails} exact={true} /> */}

            {/* <Route path="/:tab(bucketlist)/places/:id" component={PlaceDetail} exact={true} />
            <Route path="/:tab(bucketlist)/places/:id/campgrounds" component={CampgroundsDetails} exact={true} /> */}
            <Route path="/:tab(places)/places/:id" component={PlaceDetail} exact={true}  />
            {/* <Route path="/:tab(places)/places/:id/note" component={Notes} exact={true}  /> */}
            <Route path="/:tab(places)/places/:id/campgrounds" component={CampgroundsDetails} exact={true} />
            <Route path="/:tab(places)/places/:id/visitorcenters" component={VisitorCenterDetails} exact={true} />
            <Route path="/:tab(places)/places/:id/alerts" component={AlertsDetails} exact={true} />
            <Route path="/:tab(places)/places/:id/reviews" component={Reviews} exact={true} />
            <Route path="/:tab(places)/places/:id/questions" component={Questions} exact={true} />
            <Route path="/:tab(places)/places/:id/photos" component={Photos} exact={true} />
            <Route path="/:tab(places)/places/:id/myphotos" component={MyParkPhotos} exact={true} />
            <Route path="/:tab(places)/places/:id/photos/:photoid" component={PhotoDetails} exact={true} />
            {/* <Route path="/:tab(places)/places/:id/questions/:questionId" component={QuestionDetails} exact={true} /> */}

            <Route path="/:tab(map)/places/:id" component={PlaceDetail} exact={true} />
            <Route path="/:tab(map)/places/:id/campgrounds" component={CampgroundsDetails} exact={true} />
            <Route path="/:tab(map)/places/:id/visitorcenters" component={VisitorCenterDetails} exact={true} />
            <Route path="/:tab(map)/places/:id/alerts" component={AlertsDetails} exact={true} />
            <Route path="/:tab(map)/places/:id/reviews" component={Reviews} exact={true} />
            <Route path="/:tab(map)/places/:id/questions" component={Questions} exact={true} />
            <Route path="/:tab(map)/places/:id/photos" component={Photos} exact={true} />
            <Route path="/:tab(map)/places/:id/myphotos" component={MyParkPhotos} exact={true} />
            <Route path="/:tab(map)/places/:id/photos/:photoid" component={PhotoDetails} exact={true} />
            {/* <Route path="/:tab(map)/places/:id/questions/:questionId" component={QuestionDetails} exact={true} /> */}

            <Route path="/:tab(map)" component={MapView} />
            {/*<Route path="/:tab(branches)" component={BranchList} exact={true} />
            <Route path="/:tab(branches)/branch/:id" component={BranchDetail} />
            <Route path="/:tab(places|branches)/places/:id" component={FishDetail} />
            <Route path="/:tab(about)" component={About} />*/}
          </IonRouterOutlet>

          <IonTabBar slot="bottom">
            <IonTabButton tab="places" href="/places">
              <IonIcon icon={sunny} />
              <IonLabel>Parks</IonLabel>
            </IonTabButton>
            <IonTabButton tab="map" href="/map">
              <IonIcon icon={map} />
              <IonLabel>Map</IonLabel>
            </IonTabButton>
            <IonTabButton tab="profile" href="/profile">
              <IonIcon icon={person} />
              <IonLabel>Profile</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonPage>
    );
  }
};

const mapStateToProps = (state: RootState) => ({
  tokens: state.users.tokens,
  isUpdated: selectors.app.isUpdated(state.app),
  allFiltered: selectors.places.allFiltered(state.places),
  loading: state.places.loading,
  loadingMore: state.places.loadingMore,
  searchText: state.places.searchTextInHome,
  filteredTags: state.places.tagFilters,
  stateFilters: state.places.stateFilters,
  allTags: selectors.places.allTags(state.places),
  total: state.places.total,
  placesOnDisplayInHome: selectors.places.allFilteredPlacesOnHomeView(state.places),
});

const mapDispatchToProps = {
  getUserInfo: (tokens: Token) => actions.users.getUserInfo(tokens),
  refreshTokens: (refresh_token: string) => actions.users.refreshTokens(refresh_token),
  setTokens: (tokens: Token) => actions.users.setTokens(tokens),
  checkApp: () => actions.app.checkApp(),
  fetchAllParks: () => actions.places.fetchAllParks(),
  updatePlaces: () => actions.places.updatePlaces(),
  getMyList: () => actions.places.getMyList(),
  // getBucketList: () => actions.places.getBucketList(),
  searchPlaces: (searchText: string) => actions.places.setSearchTextInHome(searchText),
  updateStateFilters: (trackList: string[]) => actions.places.updateStateFilters(trackList)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppStack);
